<div class="tile-padding-first tile-padding">

  @if (detail) {

    <h3>{{detail.firstName}} {{detail.lastName}}</h3>

    <div class="btn-align tw:mb-2">
      <button class="btn tw:mr-1" type="button" [ngClass]="activeTab === 'details' ? 'btn-primary' : ''"
        (click)="setTab('details')">Details</button>
      @if (isAdmin) {
        <button class="btn tw:mr-1" type="button" [ngClass]="activeTab === 'roles' ? 'btn-primary' : ''"
          (click)="setTab('roles')">Roles</button>
        <button class="btn" type="button" [ngClass]="activeTab === 'security' ? 'btn-primary' : ''"
          (click)="setTab('security')">Security</button>
      }
    </div>

    @if (!canChange) {
      <p class="tw:text-amber-600 tw:mb-2" data-test="admin-account">This is an ADMIN account. Only an ADMIN can change it.</p>
    }

    <!-- Details tab -->
    @if (activeTab === 'details') {
      <div class="flex-search-container">
        <div class="flex-search-sub">
          <div class="flex-column">
            <label class="field__label">First name</label>
            <input type="text" class="field__control" [(ngModel)]="firstName" />
          </div>
          <div class="flex-column">
            <label class="field__label">Last name</label>
            <input type="text" class="field__control" [(ngModel)]="lastName" />
          </div>
          <div class="flex-column">
            <label class="field__label">Email</label>
            <input type="email" class="field__control" [(ngModel)]="email" />
          </div>
          <div class="flex-column">
            <label class="field__label">Mobile number</label>
            <input type="text" class="field__control" [(ngModel)]="mobileNumber" />
          </div>
        </div>
      </div>
      <label class="field__checkbox">
        <input type="checkbox" [(ngModel)]="isInternal" /> Internal user
      </label>
      <div class="btn-align tw:mt-2">
        @if (canChange) {
          <button class="btn btn-primary tw:mr-1" type="button" (click)="saveProfile()"
            [disabled]="savingProfile">Save details</button>
          @if (!isAdmin) {
            @if (detail.hasPendingActivation) {
              <button class="btn btn-primary tw:mr-1" type="button" (click)="resendActivation()">Resend activation</button>
            }
            <button class="btn btn-primary tw:mr-1" type="button" (click)="sendPasswordReset()">Send password reset</button>
          }
        }
        <button class="btn" type="button" (click)="back()">Back</button>
      </div>
      @if (detail.email !== email) {
        <p class="tw:text-amber-600 tw:mt-1">Changing the email will send a new activation link to the new
          address so the user can re-verify.</p>
      }
    }

    <!-- Roles tab -->
    @if (activeTab === 'roles' && isAdmin) {
      <div class="flex-column">
        <label class="field__label">Assigned roles</label>
        <app-searchable-select [(ngModel)]="selectedRoleIds" [items]="roles"
          displayField="description" valueField="id" multiple
          placeholder="Select roles"
          searchPlaceholder="Search roles…"></app-searchable-select>
      </div>
      @if (showClientRolesNote) {
        <p class="field__label tw:mt-1" data-test="client-roles-note">Client roles are set per client on
          <a routerLink="/clientadmin">Client Users</a>.</p>
      }
      <div class="btn-align tw:mt-2">
        <button class="btn btn-primary tw:mr-1" type="button" (click)="saveRoles()"
          [disabled]="savingRoles">Save roles</button>
        <button class="btn" type="button" (click)="back()">Back</button>
      </div>
    }

    <!-- Security tab -->
    @if (activeTab === 'security' && isAdmin) {
      <div class="tw:mb-2">
        <label class="field__checkbox">
          <input type="checkbox" [checked]="detail.options?.mfaRequired"
            (change)="toggleMfaRequired($event.target.checked)" /> MFA required
        </label>
        <p class="field__label">A mobile number must be on file to require MFA.</p>
      </div>

      <div class="tw:mb-2">
        <label class="field__label">Activation status</label>
        <p>{{detail.hasPendingActivation ? 'Pending activation (no password set yet)' : 'Activated'}}</p>
      </div>

      <div class="tw:mb-2">
        <label class="field__label">Sign-in methods</label>
        <p>Password: {{detail.hasPassword ? 'set' : 'not set'}}</p>
        @if (detail.entraObjectId) {
          <p>Entra identity: linked ({{detail.entraObjectId}})</p>
        } @else {
          <p>Entra identity: not linked</p>
        }
        @if (!detail.hasPassword && !detail.entraObjectId) {
          <p class="tw:text-red-600">This user holds neither credential and cannot sign in.</p>
        }
      </div>

      <div class="btn-align tw:mb-2">
        @if (detail.entraObjectId) {
          <button class="btn btn-primary tw:mr-1" type="button" (click)="unlinkIdentity()"
            [disabled]="changingIdentity"
            title="Clears the link only. The directory account is not changed, and the next Entra sign-in re-links it.">Unlink Entra identity</button>
        } @else {
          <button class="btn btn-primary tw:mr-1" type="button" (click)="provisionIdentity()"
            [disabled]="changingIdentity || !identityProvisionEnabled"
            title="Creates a directory account for this user. Sends no email.">Create Entra identity</button>
        }
      </div>
      @if (!detail.entraObjectId && !identityProvisionEnabled) {
        <p class="tw:text-amber-600 tw:mb-2">Identity provisioning is switched off. Enable
          <em>identity.provision</em> on the System Controls screen to create directory accounts.</p>
      }

      <div class="btn-align">
        @if (detail.hasPendingActivation) {
          <button class="btn btn-primary tw:mr-1" type="button" (click)="resendActivation()">Resend activation</button>
        }
        <button class="btn btn-primary tw:mr-1" type="button" (click)="sendPasswordReset()">Send password reset</button>
        <button class="btn" type="button" (click)="back()">Back</button>
      </div>
    }

  }

</div>
